import { Spin } from 'antd'
import CantileverCard from 'components/CantileverCard'
import { EditSaveCancelButtons } from 'features/assetDatabase'
import { useIndicationData } from 'features/indicationTriage/IndicationContext'
import { IndicationDetailCardProps } from 'features/indicationTriage/useIndicationDetailCards'
import { useGeckoLocale } from 'features/locale'
import { useGeckoPermissions } from 'features/permissions'
import React, { FC, useMemo, useRef, useState } from 'react'
import { GeckoMeasurementSystem, GeckoMeasurementUnit } from 'types'

import { useGetDamageCategories } from './damageCategory/damageCategoryAPI'
import { DamageCategoryAutoGenCard } from './damageCategory/DamageCategoryAutoGenCard'
import { EditableDamageCategoryForm } from './damageCategory/DamageCategoryForm'

export const Title = () => 'Damage Category'
export const Width = '24rem'

export const CardView: FC<IndicationDetailCardProps> = () => {
  const { indication: indicationItem } = useIndicationData()
  const { measurementSystem } = useGeckoLocale()
  const { permissions } = useGeckoPermissions()

  const { damageCategoryEntries, forceRefresh, isLoading } =
    useGetDamageCategories(indicationItem)

  const indicationDimensionString: string = useMemo(() => {
    if (!indicationItem) {
      return 'Unknown'
    }
    const { selection } = indicationItem
    if (!selection) return 'NO AREA'
    const { x: xRange, y: yRange } = selection
    const lengthMeasurementUnit =
      measurementSystem === GeckoMeasurementSystem.Imperial
        ? GeckoMeasurementUnit.Feet
        : GeckoMeasurementUnit.Meters

    const xRangeString = xRange.delta
      .convertTo(lengthMeasurementUnit)
      .toString()
    const yRangeString = yRange.delta
      .convertTo(lengthMeasurementUnit)
      .toString()

    return `${xRangeString} x ${yRangeString} Indication`
  }, [indicationItem, measurementSystem])

  const [editMode, setInEditMode] = useState(false)

  const formRef = useRef<HTMLFormElement>(null)

  const handleSave = () => {
    if (formRef.current) {
      const event = new Event('submit', { bubbles: true, cancelable: true })
      formRef.current.dispatchEvent(event)
    }
  }

  const handleCancel = () => {
    setInEditMode(false)
  }
  const handleEdit = () => {
    setInEditMode(true)
  }

  return (
    <Spin spinning={isLoading}>
      <CantileverCard>
        <CantileverCard.CardHeader
          leadingContent={indicationDimensionString}
          trailingContent={
            indicationItem && (
              <EditSaveCancelButtons
                formID={indicationItem.id}
                saveCancelButtons={editMode}
                handleSave={handleSave}
                handleEdit={handleEdit}
                handleCancel={handleCancel}
              />
            )
          }
        />
        <CantileverCard.Section>
          <EditableDamageCategoryForm
            damageCategory={damageCategoryEntries[0]}
            inEditMode={editMode}
            forceRefresh={() => forceRefresh()}
            handleCancel={handleCancel}
            measurementSystem={measurementSystem}
            ref={formRef}
            inResolveMode={false}
            userPermissions={permissions}
          />
          {damageCategoryEntries[0].data.generated && (
            <DamageCategoryAutoGenCard
              generatedDamageCategoryData={
                damageCategoryEntries[0].data.generated
              }
            />
          )}
        </CantileverCard.Section>
      </CantileverCard>
    </Spin>
  )
}
